import myelaside from './myelaside/myelaside'
import myelheader from './myelheader/myelheader'
import inlineform from './form/inlineform'
import adduserform from './form/adduserform/adduserform'
import adddraftactivityform from './form/adddraftactivityform/adddraftactivityform'
import livepicmanagetable from './mytable/livepicmanagetable/livepicmanagetable'
import livepicform from './form/livepicform/livepicform'
import roleform from './form/roleform/roleform'
import allpushform from './form/allpushform/allpushform'
import showpushform from './form/showpushform/showpushform'
import fusepushform from './form/fusepushform/fusepushform'
import activitythemeform from './form/activitythemeform/activitythemeform'
import dialog from './mydialog/tabledialog/dialog'
import addLabel from './mydialog/addLabel/addLabel'
import labeldialog from './mydialog/labeldialog/labeldialog'
import wordetaildialog from './mydialog/wordetaildialog/wordetaildialog'
import previewordetaildialog from './mydialog/previewordetaildialog/previewordetaildialog'
import testuploaddialog from '@/components/mydialog/testuploaddialog/testuploaddialog'
import picdescdialog from '@/components/mydialog/picdescdialog/picdescdialog'
import mycheckdialog from '@/components/mydialog/checkdialog/checkdialog'
import changedescdialog from '@/components/mydialog/changedescdialog/changedescdialog'
import changewordtitle from '@/components/mydialog/changewordtitle/changewordtitle'
import picmanagetable from './mytable/picmanagetable/picmanagetable'
import picshowtable from './mytable/picshowtable/picshowtable'
import picshowpicshowrectabletable from './mytable/picshowpicshowrectabletable/picshowpicshowrectabletable'
import usermanagetable from './mytable/usermanagetable/usermanagetable'
import useroutmanagetable from './mytable/useroutmanagetable/useroutmanagetable'
import worksetuptable from './mytable/worksetuptable/worksetuptable'
import userauthtable from './mytable/userauthtable/userauthtable'
import rolemanagetable from './mytable/rolemanagetable/rolemanagetable'
import classmanagetable from './mytable/classmanagetable/classmanagetable'
import mysharetable from './mytable/mysharetable/mysharetable'
import mypushtable from './mytable/mypushtable/mypushtable'
import mydownloadtable from './mytable/mydownloadtable/mydownloadtable'
import pushchanneltable from './mytable/pushchanneltable/pushchanneltable'
import draftactivitymanagetable from './mytable/draftactivitymanagetable/draftactivitymanagetable'
import picinvitemanagetable from './mytable/picinvitemanagetable/picinvitemanagetable'
import mypicinvitetable from './mytable/mypicinvitetable/mypicinvitetable'
import journaltable from './mytable/journaltable/journaltable'
import subpictable from './mytable/subpictable/subpictable'
import activitythemetable from './mytable/activitythemetable/activitythemetable'
import sharemanagetable from './mytable/sharemanagetable/sharemanagetable'
import labelmanagetable from './mytable/labelmanagetable/labelmanagetable'
import thirdaccesstable from './mytable/thirdaccesstable/thirdaccesstable'
import callbackrecordtable from './mytable/callbackrecordtable/callbackrecordtable'
import callbacktable from './mytable/callbacktable/callbacktable'
import picinvitemanageform from './form/picinvitemanageform/picinvitemanageform'
import lineecharts from './echarts/lineecharts'
import dataecharts from './echarts/dataecharts'
import firstchoose from './screenpic/firstchoose/firstchoose'
import result from './screenpic/result/result'
import review from './screenpic/review/review'
import picview from './picView/picView'
import videoView from './videoView/videoView'
import seePeopleFace from './seePeopleFace/seePeopleFace'
import downloadlogmoretable from './mytable/downloadlogmoretable/downloadlogmoretable'
import downloadlogtable from './mytable/downloadlogtable/downloadlogtable'
export {
    labelmanagetable,
    labeldialog,
    addLabel,
    classmanagetable,
    downloadlogtable,
    downloadlogmoretable,
    callbackrecordtable,
    callbacktable,
    lineecharts,
    sharemanagetable,
    thirdaccesstable,
    mypicinvitetable,
    picshowtable,
    picmanagetable,
    usermanagetable,
    rolemanagetable,
    userauthtable,
    mysharetable,
    activitythemetable,
    mypushtable,
    mydownloadtable,
    worksetuptable,
    pushchanneltable,
    draftactivitymanagetable,
    picinvitemanagetable,
    picshowpicshowrectabletable,
    journaltable,
    subpictable,
    myelaside,
    myelheader,
    adduserform,
    useroutmanagetable,
    adddraftactivityform,
    picinvitemanageform,
    roleform,
    activitythemeform,
    dialog,
    mycheckdialog,
    testuploaddialog,
    picdescdialog,
    changedescdialog,
    inlineform,
    allpushform,
    showpushform,
    firstchoose,
    result,
    review,
    fusepushform,
    picview,
    seePeopleFace,
    livepicmanagetable,
    livepicform,
    wordetaildialog,
    changewordtitle,
    previewordetaildialog,
    videoView,
    dataecharts
}